import { StateFrame } from "./shapes";

/** `ilu-no-search` (10259:23880): lupa. */
export function SemResultados() {
  return (
    <StateFrame>
      {({ x, y, stroke }) => (
        <g
          className={stroke}
          transform={`translate(${x} ${y})`}
          strokeWidth="2.2"
          strokeLinecap="round"
        >
          <circle cx="16.5" cy="16.5" r="9.5" />
          <path d="M24.2 24.2 33.5 33.5" />
        </g>
      )}
    </StateFrame>
  );
}
